import { ReactComponent as ArrowUpSquare } from 'core/assets/images/iconLibrary/arrowUpSquare.svg'
import { ReactComponent as BalanceScale } from 'core/assets/images/iconLibrary/balanceScale.svg'
import { ReactComponent as BarChartAnalytics } from 'core/assets/images/iconLibrary/barChartAnalytics.svg'
import { ReactComponent as ChatBot } from 'core/assets/images/iconLibrary/chatBot.svg'
import { ReactComponent as ChatBubble } from 'core/assets/images/iconLibrary/chatBubble.svg'
import { ReactComponent as CheckboxFlow } from 'core/assets/images/iconLibrary/checkboxFlow.svg'
import { ReactComponent as ChipCircuit } from 'core/assets/images/iconLibrary/chipCircuit.svg'
import { ReactComponent as Cloud } from 'core/assets/images/iconLibrary/cloud.svg'
import { ReactComponent as DocumentCheck } from 'core/assets/images/iconLibrary/documentCheck.svg'
import { ReactComponent as Documents } from 'core/assets/images/iconLibrary/documents.svg'
import { ReactComponent as DropdownMessage } from 'core/assets/images/iconLibrary/dropdownMessage.svg'
import { ReactComponent as FolderGit } from 'core/assets/images/iconLibrary/folderGit.svg'
import { ReactComponent as GavelJudge } from 'core/assets/images/iconLibrary/gavelJudge.svg'
import { ReactComponent as Globe } from 'core/assets/images/iconLibrary/globe.svg'
import { ReactComponent as GrowthChart } from 'core/assets/images/iconLibrary/growthChart.svg'
import { ReactComponent as LightBulb } from 'core/assets/images/iconLibrary/lightBulb.svg'
import { ReactComponent as LightningBolt } from 'core/assets/images/iconLibrary/lightningBolt.svg'
import { ReactComponent as NetworkNodes } from 'core/assets/images/iconLibrary/networkNodes.svg'
import { ReactComponent as NoLightning } from 'core/assets/images/iconLibrary/noLightning.svg'
import { ReactComponent as RefreshCheck } from 'core/assets/images/iconLibrary/refreshCheck.svg'
import { ReactComponent as ResizeMessage } from 'core/assets/images/iconLibrary/resizeMessage.svg'
import { ReactComponent as SearchLine } from 'core/assets/images/iconLibrary/searchLine.svg'
import { ReactComponent as SearchMagnifier } from 'core/assets/images/iconLibrary/searchMagnifier.svg'
import { ReactComponent as SettingsFolder } from 'core/assets/images/iconLibrary/settingsFolder.svg'
import { ReactComponent as ShieldCheck } from 'core/assets/images/iconLibrary/shieldCheck.svg'
import { ReactComponent as SliderSettings } from 'core/assets/images/iconLibrary/sliderSettings.svg'
import { ReactComponent as SpeedBoost } from 'core/assets/images/iconLibrary/speedBoost.svg'
import { ReactComponent as UploadProgress } from 'core/assets/images/iconLibrary/uploadProgress.svg'

export const IconsLibrary = {
  ResizeMessage,
  SettingsFolder,
  Documents,
  UploadProgress,
  ShieldCheck,
  SliderSettings,
  LightBulb,
  DropdownMessage,
  Cloud,
  SearchMagnifier,
  ArrowUpSquare,
  RefreshCheck,
  GavelJudge,
  NoLightning,
  ChatBubble,
  NetworkNodes,
  Globe,
  GrowthChart,
  CheckboxFlow,
  BalanceScale,
  LightningBolt,
  ChatBot,
  ChipCircuit,
  SearchLine,
  BarChartAnalytics,
  DocumentCheck,
  FolderGit,
  SpeedBoost,
}
export type IconName = keyof typeof IconsLibrary
